
import Headphones from "../../../assets/outline/Headphones.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HeadphonesIcon({ className, dataTestid = "HeadphonesIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Headphones data-testid={dataTestid} className={classes} {...rest} />
  );
}
